module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/budget_lv-f6bb4c6554041046f7d242de4cd45497.webp";